import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.ListManagePointsPage';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Página de Listagem para Distribuição de Pontos',
  },
  msgErrorModule: {
    id: `${ScopeName}.msgErrorModule`,
    defaultMessage: 'Não foi possível carregar o módulo federado',
  },
});

export default Scope;
